module.exports = __webpack_public_path__ + "media/images/grey-caret-left-d5e2ca55eaa93ac73f20c176ea963669.svg";